__turbopack_context__.v({
  "button": "errorModal-module-scss-module__N8TV0G__button",
  "buttonArea": "errorModal-module-scss-module__N8TV0G__buttonArea",
  "contents": "errorModal-module-scss-module__N8TV0G__contents",
  "errorDescription": "errorModal-module-scss-module__N8TV0G__errorDescription",
  "errorMessage": "errorModal-module-scss-module__N8TV0G__errorMessage",
  "icon": "errorModal-module-scss-module__N8TV0G__icon",
  "title": "errorModal-module-scss-module__N8TV0G__title",
});
